module.exports = __webpack_public_path__ + "img/member-vip.7582f8ca.png";